import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=b3318bfe&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b3318bfe')) {
      api.createRecord('b3318bfe', component.options)
    } else {
      api.reload('b3318bfe', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=b3318bfe&", function () {
      api.rerender('b3318bfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CRPwDPf61KpC/JS/comp/ImgFallback.vue"
export default component.exports